// extracted by mini-css-extract-plugin
export default {"jeu":"jeu_jeu__bJz7S","overlay":"jeu_overlay__acfSf","bottomBar":"jeu_bottomBar__gxi9t","context":"jeu_context__bsOUL","choice":"jeu_choice__bPcfM","boutton":"jeu_boutton__zGEEL"};